// import { title, defaultFont } from "./common-style";

const jobsListStyle = () => ({
  padding: {
    padding: "20px"
  },
  content: {
    padding: "0px",
    width: `80%`,
    margin: `0 auto`,
    minHeight: `400px`,
    position: `relative`,
  },
  roundedRectangle: {
    width: "100%",
    borderRadius: "8.9px",
    boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
    cursor: "pointer"
  },
  gridListTile: {
    marginBottom: "28px",
    listStyleType: "none",
  },
  jobTitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    color: " #004e96",
    marginBottom: "15px"
  },
  entity: {
    fontFamily: "Poppins",
    fontSize: "14.5px",
    fontWeight: "300",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#333333",
    float: "left",
  },
  tags: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: "300",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#999999",
    float: "left",
  },
  detail: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: "300",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#999999",
    float: "left",
    marginBottom: "23px"
  },
  closeDate: {
    fontFamily: "Poppins",
    fontSize: "14.5px",
    fontWeight: "300",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#999999",
    float: "right"
  },
  ul: {
    width: "100%"
  },
});

export default jobsListStyle;
